/* eslint-disable*/
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import "./Notificaions.css";
import {
  CheckBox,
  InputBox,
  SubmitButton,
  TextAreaBox,
  UploadBox,
} from "../../components/Input";
import "select2";
import axios from "axios";
import { API_URL } from "../../config";
import StateManagedSelect from "react-select";
import { Link, useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../components/toast";
import { openDB } from "idb";
import LoadingSpinner from "../../components/LoadingSpinner";

const DB_NAME = "SymbolDataDB";
const STORE_NAME = "symbol_html";

async function initDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "exchange" });
      }
    },
  });
}

async function saveSymbolsToDB(data) {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);

  // data is expected to be an object: { "NSE": "<html>...", "NFO": "..." }
  if (data && typeof data === "object") {
    for (const [exchange, html] of Object.entries(data)) {
      await store.put({
        exchange: exchange,
        html: html
      });
    }
  }

  await tx.done;
}

async function getSymbolHtmlByExchange(exchange) {
  if (!exchange) return '<input type="text" id="symbol" class="form-control" placeholder="Select Exchange First" oninput="onInput()" autocomplete="off" />';
  const db = await initDB();
  const result = await db.get(STORE_NAME, exchange);
  return result ? result.html : '<input type="text" id="symbol" class="form-control" placeholder="Enter Symbol" oninput="onInput()" autocomplete="off" />';
}

const AddNotifications = () => {
  const serviceRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [exchangeData, setexchangeData] = useState([]);
  const [serviceData, setserviceData] = useState([]);


  const [actionData, setactionData] = useState([]);
  const [symbolHtml, setSymbolHtml] = useState("");
  const [priceActionData, setpriceActionData] = useState([]);
  const [durationData, setdurationData] = useState([]);
  const [orderTypeData, setorderTypeData] = useState([]);
  const [varietyData, setvarietyData] = useState([]);
  const [productData, setproductData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [serviceLoading, setServiceLoading] = useState(false); // New loading state for initial service load
  const [priceLoading, setPriceLoading] = useState(false);
  const [quantityLoading, setQuantityLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [imagePreview, setImagePreview] = useState(null);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  const { id } = useParams();
  const navigate = useNavigate();
  const [serviceByExchange, setServiceByExchange] = useState({});
  const [isEditLoaded, setIsEditLoaded] = useState(false);
  const initialEditQtyFetch = useRef(true);
  const lastFetchedQuantityParams = useRef("");
  const [quantityStep, setQuantityStep] = useState("");
  const [formData, setFormData] = useState({
    exchange: "",
    serviceid: "",
    action: "1",
    symbol: "",
    priceAction: "@",
    quantity: "0",
    duration: "INTRADAY",
    entryPrice: "0",
    lowerCircuitPrice: "",
    upperCircuitPrice: "",
    targetPrice: "0",
    target2Price: "0",
    stoploss: "0",
    orderType: "MARKET",
    variety: "REGULAR",
    product: "MIS",
    sendToActive: true,
    setAutomatic: true,
    sendNotification: true,
    researchImage: null,
    callDescription: "",
    comments: "",
    msgBox: `NEW CALL : : BUY ( QTY-0 ) @ 0 TGT-0, 0 STOP-0.( INTRADAY ) `,
    roiGains1: "ROI : 0.00 % | Gains : Rs. 0.00",
    roiGains2: "ROI : 0.00 % | Gains : Rs. 0.00",
    roiGains3: "ROI : 0.00 % | Gains : Rs. 0.00",
  });

  const getServiceNameById = useCallback((id) => {
    if (!id) return "";
    const service = serviceData.find((item) => (item.value ?? item.id)?.toString() === id.toString());
    return service ? service.label : "";
  }, [serviceData]);

  const getActionLabelByValue = useCallback((value) => {
    const action = actionData.find((item) => item.value == value); // Use == for type coercion
    return action ? action.label : (value === "1" ? "BUY" : value === "2" ? "SELL" : "");
  }, [actionData]);

  const updateMsgBox = useCallback((data) => {
    return `NEW CALL : ${getServiceNameById(
      data.serviceid
    )} : ${getActionLabelByValue(data.action)} ${data.symbol} ( QTY-${data.quantity} ) ${data.priceAction
      } ${data.entryPrice} TGT-${data.targetPrice}, ${data.target2Price} STOP-${data.stoploss
      }.( ${data.duration} )`;
  }, [getServiceNameById, getActionLabelByValue]);
  const filteredServiceData = useMemo(() => {
    return serviceByExchange[formData.exchange] || [];
  }, [serviceByExchange, formData.exchange]);
  const resetForm = () => {
    setFormData({
      exchange: "",
      serviceid: "",
      action: "1",
      symbol: "",
      priceAction: "@",
      quantity: "0",
      duration: "INTRADAY",
      entryPrice: "0",
      lowerCircuitPrice: "",
      upperCircuitPrice: "",
      targetPrice: "0",
      target2Price: "0",
      stoploss: "0",
      orderType: "MARKET",
      variety: "REGULAR",
      product: "MIS",
      sendToActive: true,
      setAutomatic: true,
      sendNotification: true,
      researchImage: null,
      callDescription: "",
      comments: "",
      msgBox: `NEW CALL : : BUY ( QTY-0 ) @ 0 TGT-0, 0 STOP-0.( INTRADAY ) `,
      roiGains1: "ROI : 0.00 % | Gains : Rs. 0.00",
      roiGains2: "ROI : 0.00 % | Gains : Rs. 0.00",
      roiGains3: "ROI : 0.00 % | Gains : Rs. 0.00",
    });
    setImagePreview(null);
    setError(null);
  };

  useEffect(() => {
    // Listen for custom event to split/clear form
    const handleClearForm = () => {
      resetForm();
    };

    window.addEventListener('clearAddNotificationFormEvent', handleClearForm);

    return () => {
      window.removeEventListener('clearAddNotificationFormEvent', handleClearForm);
    };
  }, []);


  // Function to filter services based on exchange
  const filterServicesByExchange = (services, exchange) => {
    if (!exchange || !services.length) return [];

    const key = exchange.toLowerCase();

    let out = [];
    for (let i = 0; i < services.length; i++) {
      if (services[i][key] === 1) out.push(services[i]);
    }
    return out;
  };

  const selectedService = useMemo(() => {
    if (!formData.serviceid) return null;
    return filteredServiceData.find(
      o => o.value === formData.serviceid
    );
  }, [filteredServiceData, formData.serviceid]);

  // Function to fetch services by exchange
  const fetchServicesByExchange = async (exchange) => {
    if (!exchange) return;

    try {
      setServiceLoading(true);

      const response = await axios.get(
        `${API_URL}notification/service/dropdown?exchange=${exchange}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const rawData = response.data.data || response.data;

      const formattedData = rawData.map((item) => ({
        value: item.value ?? item.id,
        label: item.label ?? item.service_name,
        buy: item.buy || "",
        sell: item.sell || "",
        nse: item.nse || 0,
        bse: item.bse || 0,
        mcx: item.mcx || 0,
        nfo: item.nfo || 0,
        bfo: item.bfo || 0,
      }));

      // Update serviceData (used for descriptions and name lookups)
      setserviceData(formattedData);

      // Update the cache by exchange (used by filteredServiceData memo)
      setServiceByExchange((prev) => ({
        ...prev,
        [exchange]: formattedData,
      }));

    } catch (error) {
      console.error("Error fetching services:", error);
    } finally {
      setServiceLoading(false);
    }
  };


  // Update services when exchange changes
  useEffect(() => {
    if (formData.exchange) {
      fetchServicesByExchange(formData.exchange);
    }
  }, [formData.exchange]);



  // ROI Calculation Functions
  const calculateROI1 = useCallback((data) => {
    const ep = parseFloat(data.entryPrice) || 0;
    const tgt1 = parseFloat(data.targetPrice) || 0;
    const action = parseInt(data.action) || 1;
    const qty = parseInt(data.quantity) || 0;

    let diff = 0;
    let profit = 0;
    let percen = 0;

    if (action === 1) { // BUY
      diff = tgt1 - ep;
    } else if (action === 2) { // SELL
      diff = ep - tgt1;
    }

    profit = diff * qty;
    percen = ep !== 0 ? (diff * 100) / ep : 0;

    return `ROI : ${percen.toFixed(2)} % | Gains : Rs. ${profit.toFixed(2)}`;
  }, []);

  const calculateROI2 = useCallback((data) => {
    const ep = parseFloat(data.entryPrice) || 0;
    const tgt2 = parseFloat(data.target2Price) || 0;
    const action = parseInt(data.action) || 1;
    const qty = parseInt(data.quantity) || 0;

    let diff = 0;
    let profit = 0;
    let percen = 0;

    if (tgt2 !== 0) {
      if (action === 1) { // BUY
        diff = tgt2 - ep;
      } else if (action === 2) { // SELL
        diff = ep - tgt2;
      }

      profit = diff * qty;
      percen = ep !== 0 ? (diff * 100) / ep : 0;
    }

    return `ROI : ${percen.toFixed(2)} % | Gains : Rs. ${profit.toFixed(2)}`;
  }, []);

  const calculateROI3 = useCallback((data) => {
    const ep = parseFloat(data.entryPrice) || 0;
    const sl = parseFloat(data.stoploss) || 0;
    const action = parseInt(data.action) || 1;
    const qty = parseInt(data.quantity) || 0;

    let diff = 0;
    let profit = 0;
    let percen = 0;

    if (action === 1) { // BUY
      diff = sl - ep;
    } else if (action === 2) { // SELL
      diff = ep - sl;
    }

    profit = diff * qty;
    percen = ep !== 0 ? (diff * 100) / ep : 0;

    return `ROI : ${percen.toFixed(2)} % | Gains : Rs. ${profit.toFixed(2)}`;
  }, []);

  const updateAllCalculations = (data) => {
    const updatedData = { ...data };
    updatedData.msgBox = updateMsgBox(updatedData);
    updatedData.roiGains1 = calculateROI1(updatedData);
    updatedData.roiGains2 = calculateROI2(updatedData);
    updatedData.roiGains3 = calculateROI3(updatedData);
    return updatedData;
  };

  // Function to get service description based on action
  const getServiceDescription = (serviceId, action) => {
    if (!serviceId) return "";
    const service = serviceData.find((item) => (item.value ?? item.id)?.toString() === serviceId.toString());
    if (!service) return "";

    if (action === "1" || action === 1) { // BUY
      return service.buy || "";
    } else if (action === "2" || action === 2) { // SELL
      return service.sell || "";
    }
    return "";
  };

  // Function to fetch quantity from API
  const fetchQuantity = useCallback(async (exchange, symbol, serviceid, price, updateFormQty = true) => {
    if (!exchange || !symbol || !serviceid || !price || price === "0") {
      return;
    }

    try {
      setQuantityLoading(true);

      const response = await axios.post(
        `${API_URL}notification/get-quantity-symbol`,
        {
          exchange: exchange,
          symbol: symbol,
          serviceid: parseInt(serviceid),
          price: parseFloat(price)
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Handle both nested and flat response formats
      const result = response.data.data || response.data;
      const quantityData = result;

      if (quantityData) {
        // Update quantity if available
        if (quantityData.qty !== undefined && updateFormQty) {
          setFormData(prevData => {
            const updatedData = {
              ...prevData,
              quantity: quantityData.qty.toString()
            };

            // Update ROI calculations with new quantity
            updatedData.roiGains1 = calculateROI1(updatedData);
            updatedData.roiGains2 = calculateROI2(updatedData);
            updatedData.roiGains3 = calculateROI3(updatedData);
            updatedData.msgBox = updateMsgBox(updatedData);

            return updatedData;
          });
        }

        // Set dynamic step based on qty
        if (quantityData.qty !== undefined && quantityData.qty > 0) {
          setQuantityStep(quantityData.qty.toString());
        }
      }
    } catch (error) {
      console.error("Error fetching quantity:", error);
      // Don't show toast since it's optional
      // Reset to default step on error
      setQuantityStep("3");
    } finally {
      setQuantityLoading(false);
    }
  }, [token, calculateROI1, calculateROI2, calculateROI3, updateMsgBox]);

  const fetchAndStoreSymbols = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}notification/symbol`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      // API now returns { status: 200, data: { "NSE": "html...", ... } }
      const symbolDataObj = res.data.data;

      if (symbolDataObj && typeof symbolDataObj === "object") {
        await saveSymbolsToDB(symbolDataObj);

        // Refresh local state immediately if an exchange is selected
        if (formData.exchange) {
          const html = await getSymbolHtmlByExchange(formData.exchange);
          setSymbolHtml(html);
        }
        showToast.success("Symbols updated successfully");
      }
    } catch (error) {
      console.error("API Error:", error);
      showToast.error("Failed to update symbols");
    } finally {
      setLoading(false);
    }
  };

  const handleFetchSymbol = () => {
    fetchAndStoreSymbols();
  };

  const fetchPriceData = async (exchange, symbol) => {
    if (!symbol || !exchange) return;

    try {
      setPriceLoading(true);

      const response = await axios.post(
        `${API_URL}backendApi/get-price`,
        { exchange, symbol },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const priceData = response.data;

      setFormData((prevData) => {
        const updatedData = {
          ...prevData,
          entryPrice: priceData.last_price?.toString() || prevData.entryPrice,
          lowerCircuitPrice: priceData.lower_circuit_limit?.toString() || "",
          upperCircuitPrice: priceData.upper_circuit_limit?.toString() || "",
        };

        updatedData.msgBox = updateMsgBox(updatedData);
        updatedData.roiGains1 = calculateROI1(updatedData);
        updatedData.roiGains2 = calculateROI2(updatedData);
        updatedData.roiGains3 = calculateROI3(updatedData);

        return updatedData;
      });

      // Quantity will be fetched by the useEffect when entryPrice is updated
    } catch (error) {
      console.error("Error fetching price data:", error);
    } finally {
      setPriceLoading(false);
    }
  };

  // getActionLabelByValue removed from here (moved up)

  const fetchNotification = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}notification/add/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = response.data.notification;

      const updatedData = {
        exchange: data.exchange,
        serviceid: data.serviceid.toString(),
        action: data.action.toString(),
        symbol: data.symbol,
        priceAction: data.price_action,
        quantity: data.quantity.toString(),
        duration: data.duration,
        entryPrice: data.entry_price,
        lowerCircuitPrice: data.lower_circuit_price || "",
        upperCircuitPrice: data.upper_circuit_price || "",
        targetPrice: data.target_price,
        target2Price: data.target2_price,
        stoploss: data.stoploss,
        orderType: data.order_type,
        variety: data.data_variety,
        product: data.data_product,
        sendToActive: data.isactive === 1,
        setAutomatic: data.automan === 1,
        sendNotification: false,
        researchImage: data.research_image,
        callDescription: data.calldescription || "",
        comments: data.comments || "",
      };

      updatedData.msgBox = updateMsgBox(updatedData);
      updatedData.roiGains1 = calculateROI1(updatedData);
      updatedData.roiGains2 = calculateROI2(updatedData);
      updatedData.roiGains3 = calculateROI3(updatedData);

      setFormData(updatedData);
      
      if (data.research_image) {
        setImagePreview(data.research_image);
      }
    } catch (error) {
      setError(error.message);
      showToast.error("Failed to fetch notification data");
    } finally {
      setLoading(false);
    }
  };

  const fetchDropdownData = async (url, setData) => {
    try {
      const response = await axios.get(`${API_URL}${url}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const rawData = response.data.data || response.data;

      const formattedData = rawData.map((item) => ({
        value: item.value ?? item.id,
        label: item.label ?? item.service_name,
      }));

      setData(formattedData);
    } catch (error) {
      setError(error.message);
    }
  };

  const loadAllDropdowns = async () => {
    await Promise.all([
      fetchDropdownData("notification/dropdown/exchange", setexchangeData),
      fetchDropdownData("notification/dropdown/action", setactionData),
      fetchDropdownData(
        "notification/dropdown/price-action",
        setpriceActionData
      ),
      fetchDropdownData("notification/dropdown/duration", setdurationData),
      fetchDropdownData("notification/dropdown/order-type", setorderTypeData),
      fetchDropdownData("notification/dropdown/data-variety", setvarietyData),
      fetchDropdownData("notification/dropdown/data-product", setproductData),
    ]);
  };

  useEffect(() => {
    if (id) {
      fetchNotification(id);
    } else {
      resetForm();
    }
  }, [id]);

  useEffect(() => {
    const fetchSymbols = async () => {
      const html = await getSymbolHtmlByExchange(formData.exchange);
      setSymbolHtml(html);
    };
    fetchSymbols();
  }, [formData.exchange]);

  const handleSymbolSelected = (symbol) => {
    if (symbol && formData.exchange) {
      fetchPriceData(formData.exchange, symbol);
    }
  };

  // Handle the injected input's oninput event
  useEffect(() => {
    // Define the global function expected by the injected HTML
    window.onInput = function () {
      const val = document.getElementById("symbol").value;
      const opts = document.getElementById('symbolsdata')?.childNodes;
      let isSelected = false;
      if (opts) {
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].value === val) {
            isSelected = true;
            break;
          }
        }
      }

      // Update React State
      setFormData(prev => {
        const updated = { ...prev, symbol: val };
        updated.msgBox = updateMsgBox(updated);
        return updated;
      });

      if (isSelected) {
        handleSymbolSelected(val);
      }
    };

    return () => {
      window.onInput = null;
    };
  }, [formData.exchange, serviceData, actionData]); // Depend on things needed for updates

  useEffect(() => {
    const inputEl = document.getElementById("symbol");
    if (inputEl) {
      inputEl.value = formData.symbol || "";
    }
  }, [formData.symbol, symbolHtml]);

  useEffect(() => {
    const initLoad = async () => {
      try {
        setInitialLoading(true);
        await loadAllDropdowns();

        if (id) await fetchNotification(id);
      } catch (err) {
        console.error(err);
      } finally {
        setInitialLoading(false);
        setIsEditLoaded(true);
      }
    };
    initLoad();
  }, [id]);

  // Effect to fetch quantity when relevant fields change
  // useEffect(() => {
  //   if (formData.exchange && formData.symbol && formData.serviceid && formData.entryPrice && formData.entryPrice !== "0") {
  //     fetchQuantity(formData.exchange, formData.symbol, formData.serviceid, formData.entryPrice);
  //   }
  // }, [formData.exchange, formData.symbol, formData.serviceid, formData.entryPrice]);

  useEffect(() => {
    if (!isEditLoaded) return;

    if (
      formData.exchange &&
      formData.symbol &&
      formData.serviceid &&
      formData.entryPrice &&
      formData.entryPrice !== "0"
    ) {
      const currentParams = `${formData.exchange}-${formData.symbol}-${formData.serviceid}-${formData.entryPrice}`;
      if (lastFetchedQuantityParams.current === currentParams) {
        return;
      }
      
      const isInitial = id && initialEditQtyFetch.current;
      
      fetchQuantity(
        formData.exchange,
        formData.symbol,
        formData.serviceid,
        formData.entryPrice,
        !isInitial
      );
      
      lastFetchedQuantityParams.current = currentParams;
      
      if (isInitial) {
        initialEditQtyFetch.current = false;
      }
    }
  }, [
    formData.symbol,      // 🔥 symbol change
    formData.exchange,
    formData.serviceid,
    formData.entryPrice,
    fetchQuantity,
    isEditLoaded,
    id
  ]);


  const handleQuantityAdjust = (amount) => {
    const current = parseFloat(formData.quantity) || 0;
    const newValue = Math.max(0, current + amount);
    handleChange({
      target: { name: 'quantity', value: newValue.toString(), type: 'number', checked: false }
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    const updatedForm = {
      ...formData,
      [name]: newValue,
    };

    if (id && ["targetPrice", "target2Price", "stoploss"].includes(name)) {
      updatedForm.sendNotification = true;
    }

    updatedForm.msgBox = updateMsgBox(updatedForm);
    updatedForm.roiGains1 = calculateROI1(updatedForm);
    updatedForm.roiGains2 = calculateROI2(updatedForm);
    updatedForm.roiGains3 = calculateROI3(updatedForm);
    setFormData(updatedForm);
  };

  const handleSelectExchange = async (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    setFormData((prev) => ({
      ...prev,
      exchange: selectedValue,
      serviceid: null,
      callDescription: "",
    }));

    if (formData.symbol && selectedValue) {
      fetchPriceData(selectedValue, formData.symbol);
    }

    // Auto open service dropdown
    if (selectedValue) {
      setTimeout(() => {
        serviceRef.current?.focus();
      }, 100);
    }
  };



  const handleSelectService = useCallback((selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    setFormData((prev) => {
      const updatedForm = {
        ...prev,
        serviceid: selectedValue,
        callDescription: getServiceDescription(selectedValue, prev.action),
      };

      updatedForm.msgBox = updateMsgBox(updatedForm);
      return updatedForm;
    });

  }, [serviceData, actionData]);


  const handleSelectAction = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    const updatedForm = {
      ...formData,
      action: selectedValue,
    };

    // Auto-populate call description based on selected service and new action
    const description = getServiceDescription(formData.serviceid, selectedValue);
    updatedForm.callDescription = description;

    updatedForm.msgBox = updateMsgBox(updatedForm);
    updatedForm.roiGains1 = calculateROI1(updatedForm);
    updatedForm.roiGains2 = calculateROI2(updatedForm);
    updatedForm.roiGains3 = calculateROI3(updatedForm);
    setFormData(updatedForm);
  };

  const handleSelectPriceAction = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    const updatedForm = {
      ...formData,
      priceAction: selectedValue,
    };

    updatedForm.msgBox = updateMsgBox(updatedForm);
    setFormData(updatedForm);
  };

  const handleSelectDuration = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    const updatedForm = {
      ...formData,
      duration: selectedValue,
    };

    updatedForm.msgBox = updateMsgBox(updatedForm);
    setFormData(updatedForm);
  };

  const handleSelectOrderType = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    setFormData((prevValues) => ({
      ...prevValues,
      orderType: selectedValue,
    }));
  };

  const handleSelectVariety = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    setFormData((prevValues) => ({
      ...prevValues,
      variety: selectedValue,
    }));
  };

  const handleSelectProduct = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    setFormData((prevValues) => ({
      ...prevValues,
      product: selectedValue,
    }));
  };

  const validateTradeLogic = () => {
    const ep = parseFloat(formData.entryPrice);
    const tgt1 = parseFloat(formData.targetPrice);
    const tgt2 = parseFloat(formData.target2Price);
    const sl = parseFloat(formData.stoploss);
    const action = parseInt(formData.action);

    if (!ep || ep <= 0) {
      showToast.error("Entry Price must be greater than 0");
      return false;
    }

    if (!tgt1 || tgt1 <= 0) {
      showToast.error("Target 1 must be greater than 0");
      return false;
    }

    if (!sl || sl <= 0) {
      showToast.error("Stoploss must be greater than 0");
      return false;
    }

    // ===== BUY VALIDATION =====
    if (action === 1) {
      if (!(ep < tgt1)) {
        showToast.error("BUY Rule: Entry Price must be less than Target 1");
        return false;
      }

      if (tgt2 && !(tgt1 < tgt2)) {
        showToast.error("BUY Rule: Target 1 must be less than Target 2");
        return false;
      }

      if (!(sl < ep)) {
        showToast.error("BUY Rule: Stoploss must be less than Entry Price");
        return false;
      }
    }

    // ===== SELL VALIDATION =====
    if (action === 2) {
      if (!(ep > tgt1)) {
        showToast.error("SELL Rule: Entry Price must be greater than Target 1");
        return false;
      }

      if (tgt2 && !(tgt1 > tgt2)) {
        showToast.error("SELL Rule: Target 1 must be greater than Target 2");
        return false;
      }

      if (!(sl > ep)) {
        showToast.error("SELL Rule: Stoploss must be greater than Entry Price");
        return false;
      }
    }

    return true;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateTradeLogic()) return;



    const formPayload = new FormData();
    formPayload.append("exchange", formData.exchange);
    formPayload.append("serviceid", formData.serviceid);
    formPayload.append("action", formData.action);
    formPayload.append("symbol", formData.symbol);
    formPayload.append("price_action", formData.priceAction);
    formPayload.append("quantity", formData.quantity);
    formPayload.append("duration", formData.duration);
    formPayload.append("entry_price", formData.entryPrice);
    formPayload.append("lower_circuit_price", formData.lowerCircuitPrice);
    formPayload.append("upper_circuit_price", formData.upperCircuitPrice);
    formPayload.append("target_price", formData.targetPrice);
    formPayload.append("target2_price", formData.target2Price);
    formPayload.append("stoploss", formData.stoploss);
    formPayload.append("order_type", formData.orderType);
    formPayload.append("data_variety", formData.variety);
    formPayload.append("data_product", formData.product);
    formPayload.append("isactive", formData.sendToActive ? 1 : 0);
    formPayload.append("automan", formData.setAutomatic ? 1 : 0);
    // formPayload.append("isnotified", formData.sendNotification ? 1 : 0);
    formPayload.append("notifyMe", formData.sendNotification ? 1 : 0);

    if (formData.researchImage) {
      formPayload.append("research_image", formData.researchImage);
    }

    formPayload.append("calldescription", formData.callDescription);
    formPayload.append("comments", formData.comments);

    try {
      setLoading(true);
      const url = id
        ? `${API_URL}notification/save?id=${id}`
        : `${API_URL}notification/save`;

      const response = await axios.post(url, formPayload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success === true || response.status === 200) {
        showToast.success(
          id ? "Notification updated successfully" : "Notification created successfully"
        );
        navigate("/research/notifications");
      }
    } catch (error) {
      console.error("Error saving notification:", error);
      showToast.error("There was an error saving the notification");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-header-fixed page-sidebar-fixed fade in mt-5" style={{ marginTop: "100px" }}>
      <div className="panel panel-default with-rounded-corner with-shadow">
        <div className="panel-heading border-0 mb-1">
          <span className="panel-title">
            {id ? "Edit" : "Add"} Notification
          </span>
        </div>
        <div className="panel-body">
          {loading && <LoadingSpinner />}
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-2 mb-2">
                <label className="control-label">Exchange</label>
                <StateManagedSelect
                  options={exchangeData}
                  value={
                    formData.exchange
                      ? exchangeData.find(
                        (option) => option.value == formData.exchange
                      )
                      : null
                  }
                  onChange={handleSelectExchange}
                  placeholder="Select Exchange"
                />
              </div>
              <div className="col-md-3">
                <label className="control-label">Service</label>
                <StateManagedSelect
                  ref={serviceRef}
                  options={filteredServiceData}
                  value={
                    formData.serviceid
                      ? filteredServiceData.find(
                        (option) => option.value.toString() === formData.serviceid.toString()
                      )
                      : null
                  }
                  onChange={handleSelectService}
                  placeholder="Select Service"
                  isLoading={serviceLoading}

                  /* ✅ FIX */
                  closeMenuOnSelect={true}
                  blurInputOnSelect={false}   // 🔥 IMPORTANT
                  openMenuOnFocus={true}      // 🔥 IMPORTANT
                  menuPlacement="auto"
                  isClearable={false}
                />

                {/* Quick status indicator */}
                {!serviceLoading && filteredServiceData.length === 0 && formData.exchange && (
                  <div className="text-xs text-yellow-500 mt-1">
                    No services available for {formData.exchange}
                  </div>
                )}
              </div>
              <div className="col-md-2">
                <label className="control-label">Action</label>
                <StateManagedSelect
                  options={actionData}
                  value={
                    formData.action
                      ? actionData.find(
                        (option) => option.value == formData.action
                      )
                      : null
                  }
                  onChange={handleSelectAction}
                  placeholder="Select Action"
                />
              </div>
              <div className="col-md-5">
                <label className="control-label">
                  Symbol{" "}
                  <Link
                    className={`reload_symbols cursor-pointer ${hovered ? "text-underline" : ""
                      }`}
                    onMouseOver={() => setHovered(true)}
                    onMouseOut={() => setHovered(false)}
                    style={{ fontSize: "11.52px", color: "#007AFF" }}
                    onClick={handleFetchSymbol}
                  >
                    Click here to update symbols
                  </Link>
                </label>

                <div
                  dangerouslySetInnerHTML={{ __html: symbolHtml }}
                  style={{ minHeight: '34px' }}
                />

                {/* 
                  Hidden input to ensure form logic that might rely on specific DOM structure 
                  doesn't break, though we are syncing state via window.onInput. 
                  The injected HTML contains an input with id="symbol", so we don't need another one.
                */}
              </div>
              <div className="col-md-2">
                <label className="control-label">Price Action</label>
                <StateManagedSelect
                  options={priceActionData}
                  value={
                    formData.priceAction
                      ? priceActionData.find(
                        (option) => option.value === formData.priceAction
                      )
                      : null
                  }
                  onChange={handleSelectPriceAction}
                  placeholder="Select Price Action"
                />
              </div>
              <div className="col-md-2">
                <label className="form-label">Quantity</label>
                <div style={{ display: 'flex' }}>
                  <button 
                    type="button" 
                    className="btn btn-default" 
                    style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, background: '#f8f9fa', border: '1px solid #ced4da', borderRight: 0 }}
                    onClick={() => handleQuantityAdjust(-(parseFloat(quantityStep) || 1))}
                    disabled={quantityLoading}
                  >
                    -
                  </button>
                  <input
                    type="number"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleChange}
                    step={quantityStep}
                    min="0"
                    className="form-control text-center hide-spinners"
                    style={{ borderRadius: 0 }}
                    placeholder={quantityLoading ? "Loading..." : "Enter qty"}
                  />
                  <button 
                    type="button" 
                    className="btn btn-default" 
                    style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, background: '#f8f9fa', border: '1px solid #ced4da', borderLeft: 0 }}
                    onClick={() => handleQuantityAdjust(parseFloat(quantityStep) || 1)}
                    disabled={quantityLoading}
                  >
                    +
                  </button>
                </div>

                {quantityLoading && (
                  <div className="text-xs text-blue-500 mt-1">
                    Calculating quantity...
                  </div>
                )}
              </div>

              <div className="col-md-2">
                <label className="control-label">Duration</label>
                <StateManagedSelect
                  options={durationData}
                  value={
                    formData.duration
                      ? durationData.find(
                        (option) => option.value === formData.duration
                      )
                      : null
                  }
                  onChange={handleSelectDuration}
                  placeholder="Select Duration"
                />
              </div>
              <div className="col-md-2">
                <InputBox
                  label="Entry Price"
                  fieldname="entryPrice"
                  value={formData.entryPrice}
                  onChange={handleChange}
                  type="number"
                  placeholder={
                    priceLoading ? "Loading..." : "Enter entry price"
                  }
                />
              </div>
              <div className="col-md-2">
                <InputBox
                  label="Lower Circuit Price"
                  fieldname="lowerCircuitPrice"
                  value={formData.lowerCircuitPrice}
                  onChange={handleChange}
                  jsScript={{ disabled: true }}
                  placeholder={
                    priceLoading ? "Loading..." : "Enter Lower Circuit Price"
                  }
                />
              </div>
              <div className="col-md-2">
                <InputBox
                  label="Upper Circuit Price"
                  fieldname="upperCircuitPrice"
                  value={formData.upperCircuitPrice}
                  onChange={handleChange}
                  jsScript={{ disabled: true }}
                  placeholder={
                    priceLoading ? "Loading..." : "Enter Upper Circuit Price"
                  }
                />
              </div>
              <div className="col-md-4">
                <InputBox
                  label="Target Price"
                  fieldname="targetPrice"
                  value={formData.targetPrice}
                  onChange={handleChange}
                  type="number"
                  placeholder="Enter target price"
                />
              </div>
              <div className="col-md-4">
                <InputBox
                  label="Target2 Price"
                  fieldname="target2Price"
                  value={formData.target2Price}
                  onChange={handleChange}
                  type="number"
                  placeholder="Enter target2 price"
                />
              </div>
              <div className="col-md-4">
                <InputBox
                  label="Stoploss"
                  fieldname="stoploss"
                  value={formData.stoploss}
                  onChange={handleChange}
                  type="number"
                  placeholder="Enter stoploss"
                />
              </div>
              <div className="col-md-4">
                <label className="control-label">Order Type</label>
                <StateManagedSelect
                  options={orderTypeData}
                  value={
                    formData.orderType
                      ? orderTypeData.find(
                        (option) => option.value === formData.orderType
                      )
                      : null
                  }
                  onChange={handleSelectOrderType}
                  placeholder="Select Order Type"
                />
              </div>
              <div className="col-md-4">
                <label className="control-label">Variety / Complexity</label>
                <StateManagedSelect
                  options={varietyData}
                  value={
                    formData.variety
                      ? varietyData.find(
                        (option) => option.value === formData.variety
                      )
                      : null
                  }
                  onChange={handleSelectVariety}
                  placeholder="Select Variety / Complexity"
                />
              </div>
              <div className="col-md-4">
                <label className="control-label">Product / Position</label>
                <StateManagedSelect
                  options={productData}
                  value={
                    formData.product
                      ? productData.find(
                        (option) => option.value === formData.product
                      )
                      : null
                  }
                  onChange={handleSelectProduct}
                  placeholder="Select Product / Position"
                />
              </div>
              <div className="col-md-2 mt-2">
                <CheckBox
                  label="Set To Active"
                  fieldname="sendToActive"
                  checked={formData.sendToActive}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-2 mt-2">
                <CheckBox
                  label="Send Automatic"
                  fieldname="setAutomatic"
                  checked={formData.setAutomatic}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-2 mt-2">
                <CheckBox
                  label="Send Notification"
                  fieldname="sendNotification"
                  checked={formData.sendNotification}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-5 mt-3">
                <UploadBox
                  label="Upload Research Image File"
                  fieldname="researchImage"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setFormData({
                      ...formData,
                      researchImage: file,
                    });

                    // 🔹 Set preview if a new image file is selected
                    if (file) {
                      const reader = new FileReader();
                      reader.onload = () => {
                        setImagePreview(reader.result);
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                />
                {imagePreview && (
                  <div className="mt-2">
                    <label className="control-label d-block mb-1">
                      Image Preview
                    </label>
                    <img
                      src={imagePreview}
                      alt="Research Preview"
                      style={{
                        maxWidth: "200px",
                        maxHeight: "200px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="col-md-4">
                <label htmlFor="callDescription" className="form-label">
                  Call Description
                </label>
                <textarea
                  id="callDescription"
                  name="callDescription"
                  value={formData.callDescription}
                  onChange={handleChange}
                  placeholder="Enter Call Description"
                  rows={4}
                  className="form-control"
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="comments" className="form-label">
                  Comments
                </label>
                <textarea
                  id="comments"
                  name="comments"
                  value={formData.comments}
                  onChange={handleChange}
                  placeholder="Enter Comments"
                  rows={4}
                  className="form-control"
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="msgBox" className="form-label">
                  Msg Box
                </label>
                <textarea
                  id="msgBox"
                  name="msgBox"
                  value={formData.msgBox}
                  onChange={handleChange}
                  placeholder="Enter Notification Msg"
                  rows={4}
                  className="form-control"
                  disabled={true}
                />
              </div>

              <div className="col-md-4 mt-2">
                <InputBox
                  label="TGT1 - ROI & Gains"
                  fieldname="roiGains1"
                  value={formData.roiGains1}
                  onChange={handleChange}
                  jsScript={{ disabled: true, readOnly: true }}
                />
              </div>
              <div className="col-md-4 mt-2">
                <InputBox
                  label="TGT2 - ROI & Gains"
                  fieldname="roiGains2"
                  value={formData.roiGains2}
                  onChange={handleChange}
                  jsScript={{ disabled: true, readOnly: true }}
                />
              </div>
              <div className="col-md-4 mt-2">
                <InputBox
                  label="SL - ROI & Gains"
                  fieldname="roiGains3"
                  value={formData.roiGains3}
                  onChange={handleChange}
                  jsScript={{ disabled: true, readOnly: true }}
                />
              </div>
              <div className="col-md-12 mt-3">
                <SubmitButton
                  handleSubmit={handleSubmit}
                  pageBack="/research/notifications"
                />
              </div>
            </div>
          </form>
        </div>
      </div >
    </div >
  );
};

export default AddNotifications;